import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Diamond, Mail, Phone, MapPin, Instagram, Facebook, Twitter } from 'lucide-react';
import LegalModal from '../LegalModal';
import { legalContent } from '../../data/legalContent';

const Footer = () => {
  const [activeModal, setActiveModal] = useState(null);

  const legalLinks = [
    { key: 'terms', label: 'Terms of Service' },
    { key: 'privacy', label: 'Privacy Policy' },
    { key: 'cookies', label: 'Cookie Policy' },
    { key: 'refund', label: 'Refund & Returns' },
  ];

  return (
    <>
      <footer className="bg-[#0a0a0a] border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-5">
                <Diamond className="w-6 h-6 text-[#2EC866]" />
                <div className="flex flex-col">
                  <span className="text-white font-bold text-lg tracking-wider" style={{ fontFamily: 'Playfair Display, serif' }}>
                    LUXO-MARKET
                  </span>
                  <span className="text-[#2EC866] text-[8px] tracking-[0.3em] uppercase -mt-1">
                    Luxury Accessories
                  </span>
                </div>
              </Link>
              <p className="text-gray-500 text-sm leading-relaxed">
                Premium luxury accessories for watches, iPhones & more. Handcrafted with the finest materials.
              </p>
              <div className="flex gap-4 mt-6">
                <a href="#" className="text-gray-500 hover:text-[#2EC866] transition-colors duration-300">
                  <Instagram className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-500 hover:text-[#2EC866] transition-colors duration-300">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-500 hover:text-[#2EC866] transition-colors duration-300">
                  <Twitter className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Quick Links</h4>
              <ul className="space-y-3">
                {[
                  { to: '/shop', label: 'Shop All' },
                  { to: '/shop?category=watch-accessories', label: 'Watch Accessories' },
                  { to: '/shop?category=watch-straps', label: 'Watch Straps' },
                  { to: '/shop?category=phone-cases', label: 'Phone Cases' },
                  { to: '/shop?category=jewelry-accessories', label: 'Jewelry Accessories' },
                ].map(link => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-gray-500 hover:text-[#2EC866] text-sm transition-colors duration-300">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Customer Service */}
            <div>
              <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Customer Service</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/account" className="text-gray-500 hover:text-[#2EC866] text-sm transition-colors duration-300">
                    My Account
                  </Link>
                </li>
                <li>
                  <Link to="/account" className="text-gray-500 hover:text-[#2EC866] text-sm transition-colors duration-300">
                    Track Order
                  </Link>
                </li>
                {legalLinks.map(link => (
                  <li key={link.key}>
                    <button
                      onClick={() => setActiveModal(link.key)}
                      className="text-gray-500 hover:text-[#2EC866] text-sm transition-colors duration-300 cursor-pointer bg-transparent border-none p-0 text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Contact Us</h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <Mail className="w-4 h-4 text-[#2EC866] mt-0.5 flex-shrink-0" />
                  <span className="text-gray-500 text-sm">contact@luxo-market.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <Phone className="w-4 h-4 text-[#2EC866] mt-0.5 flex-shrink-0" />
                  <span className="text-gray-500 text-sm">+447 418 60 49 30</span>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 text-[#2EC866] mt-0.5 flex-shrink-0" />
                  <span className="text-gray-500 text-sm">50 Princes Street, Ipswich, England</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-600 text-xs">
              &copy; {new Date().getFullYear()} Luxo-Market. All rights reserved.
            </p>
            <div className="flex gap-6">
              {legalLinks.map(link => (
                <button
                  key={link.key}
                  onClick={() => setActiveModal(link.key)}
                  className="text-gray-600 hover:text-gray-400 text-xs transition-colors cursor-pointer bg-transparent border-none p-0"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal
        isOpen={activeModal !== null}
        onClose={() => setActiveModal(null)}
        data={activeModal ? legalContent[activeModal] : null}
        type={activeModal}
      />
    </>
  );
};

export default Footer;
